/**
 * @fileoverview GET handler for the "/oauth/applications/:client_id" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError, reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { oauthApplicationsClientId } from "./constants";
import type { GetOAuthApplicationDataError, OAuthApplicationResult } from "./types";
import { isOAuthApplicationResult } from "./validators";

export const getOAuthApplicationData = reactQueryFetcherAdapter(
  oauthApplicationsClientId,
  createGetFetcherFunctionWithShadowError<GetOAuthApplicationDataError>()(
    (signal: AbortSignal, clientId: string): Promise<OAuthApplicationResult> => {
      return fetch(`/oauth/applications/${clientId}`, "GET", {}, { signal }, { propagateFetchRequestError: false });
    }
  ),
  isOAuthApplicationResult
);
